import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

const useFetchingEventTags = () => {
  const { data: availableTags = [] } = useQuery({
    queryKey: ["experience-tags"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("event_tags")
        .select("tag")
        .order("tag");

      if (error) {
        console.error("❌ Error fetching tags:", error);
        throw error;
      }

      // Remove duplicates and return unique tags
      const uniqueTags = [...new Set(data.map((t) => t.tag))];
      return uniqueTags;
    },
  });

  return useMemo(() => { 
    return {
      availableTags, // use object so we can easily add more properties in the future
    };
  }, [availableTags]);
};

export default useFetchingEventTags;
